import { Box } from '@gousto-internal/citrus-react'
import React from 'react'

import { PromoBanner, PromoBannerText } from './components/PromoBanner'
import { BlackFridayPromoBanner } from './components/PromoBanner/BlackFridayPromoBanner'
import type { Recipe } from '@library/menu-service'
import { LandingPageContent } from '../../landing-page-content/src/LandingPageContent'
import { LandingPageAboveTheFold } from '../../landing-page-above-the-fold/src/LandingPageAboveTheFold'

export type HomepageProps = {
  applyDiscount: () => void
  isPromoBannerVisible: boolean
  promoBannerText: string
  onSignupCTAClick: () => void
  signupCTA: string
  recipes: Recipe[]
  isBlackFridayPromotion: boolean
}

export function Homepage({
  applyDiscount,
  promoBannerText,
  isPromoBannerVisible,
  signupCTA,
  onSignupCTAClick,
  recipes,
  isBlackFridayPromotion,
}: HomepageProps) {
  return (
    <Box data-testid="homepage-redesigned">
      {isPromoBannerVisible && isBlackFridayPromotion && (
        <BlackFridayPromoBanner applyDiscount={applyDiscount} />
      )}
      {isPromoBannerVisible && !isBlackFridayPromotion && (
        <PromoBanner applyDiscount={applyDiscount}>
          <PromoBannerText>{promoBannerText}</PromoBannerText>
        </PromoBanner>
      )}
      <LandingPageAboveTheFold onCTAClick={onSignupCTAClick} signupCTA={signupCTA} />
      <LandingPageContent
        onSignupCTAClick={onSignupCTAClick}
        recipes={recipes}
        signupCTA={signupCTA}
      />
    </Box>
  )
}
